import { createSelector } from 'reselect';

const selectAppGlobal = (state) => state.get('global');

const makeSelectAppError = () =>
  createSelector(selectAppGlobal, (state) => state.get('error'));

export { makeSelectAppError };



// WEBPACK FOOTER //
// ./app/containers/AppError/selectors.js